module.exports = __webpack_public_path__ + "img/sustainability.9ee679f.jpg";